import { Box, ButtonBase, Collapse, Typography } from "@mui/material";
import { COLOR_CONSTANTS } from "src/domains/shared/constants/styles";

export interface SelectionActionDockProps {
  open: boolean;
  /** 서피스·카운트·확인 버튼 색 — error=삭제, primary=일반 실행 */
  intent: "error" | "primary";
  /** 선택 개수 문구 (번역 완료 문자열) — interpolation 은 호출부 책임 */
  countLabel: string;
  /** 전체 선택/선택 해제 라벨 — 전체 선택 여부에 따른 라벨 결정은 호출부 책임 */
  selectAllLabel: string;
  confirmLabel: string;
  cancelLabel: string;
  selectAllDisabled: boolean;
  confirmDisabled: boolean;
  onSelectAll: () => void;
  onConfirm: () => void;
  onCancel: () => void;
  /** dock 위 여백(px) — Collapse 내부라 닫힘 시 함께 접힌다 (기본 8) */
  topGapPx?: number;
}

export function SelectionActionDock({
  open,
  intent,
  countLabel,
  selectAllLabel,
  confirmLabel,
  cancelLabel,
  selectAllDisabled,
  confirmDisabled,
  onSelectAll,
  onConfirm,
  onCancel,
  topGapPx = 8,
}: SelectionActionDockProps) {
  const palette = INTENT_PALETTE[intent];
  return (
    <Collapse in={open} timeout={200}>
      <Box sx={{ height: `${topGapPx}px` }} />
      <Box sx={[dockBar, { backgroundColor: palette.surface }]}>
        <Typography sx={[dockCount, { color: palette.main }]}>
          {countLabel}
        </Typography>
        <Box sx={dockActions}>
          <ButtonBase
            sx={dockTextButton}
            disabled={selectAllDisabled}
            onClick={onSelectAll}
          >
            <Typography sx={dockButtonText}>{selectAllLabel}</Typography>
          </ButtonBase>
          <ButtonBase
            sx={[dockTextButton, { "&:hover": { backgroundColor: palette.hover } }]}
            disabled={confirmDisabled}
            onClick={onConfirm}
          >
            <Typography sx={[dockButtonText, { color: palette.main }]}>
              {confirmLabel}
            </Typography>
          </ButtonBase>
          <ButtonBase sx={dockTextButton} onClick={onCancel}>
            <Typography sx={dockButtonText}>{cancelLabel}</Typography>
          </ButtonBase>
        </Box>
      </Box>
    </Collapse>
  );
}

const INTENT_PALETTE = {
  error: {
    main: COLOR_CONSTANTS.error.main,
    surface: COLOR_CONSTANTS.error._states.selected,
    hover: COLOR_CONSTANTS.error._states.selected,
  },
  primary: {
    main: COLOR_CONSTANTS.primary.main,
    surface: COLOR_CONSTANTS.primary._states.selected,
    hover: COLOR_CONSTANTS.primary._states.hover,
  },
} as const;

const dockBar = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "8px",
  padding: "5px 6px 5px 10px",
  borderRadius: "8px",
} as const;

const dockCount = {
  fontSize: "11px",
  fontWeight: 600,
  whiteSpace: "nowrap",
  paddingLeft: "6px",
} as const;

const dockActions = {
  display: "flex",
  alignItems: "center",
  gap: "2px",
} as const;

const dockTextButton = {
  padding: "4px 7px",
  borderRadius: "6px",
  whiteSpace: "nowrap",
  "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.05)" },
  "&.Mui-disabled": { opacity: 0.4 },
} as const;

const dockButtonText = {
  fontSize: "11px",
  fontWeight: 600,
  color: "rgba(0, 0, 0, 0.55)",
} as const;
